import { Menu as ReactAriaMenu, MenuTrigger } from "react-aria-components";

import styles from "./menu.module.css";
import Button, { ButtonProps } from "./forms/button";
import DropdownPopover from "./dropdown-popover";

interface MenuBaseProps {
  /**
   * Non-interactive content above the items - who you are, what this menu acts
   * on. Kept outside the menu list so it is not focusable and is not announced
   * as a choice.
   */
  header?: React.ReactNode;
  children?: React.ReactNode;
}

/**
 * A menu takes exactly one opener, and the type enforces that rather than
 * leaving a menu with nothing to open it.
 *
 * `trigger` renders pallet's Button and covers most cases. `triggerNode` takes
 * a custom opener - an avatar with a name and a chevron, say - and must render
 * a single focusable element, because react-aria wires the menu behaviour onto
 * whatever is there.
 */
type MenuProps = MenuBaseProps &
  (
    | { trigger: ButtonProps; triggerNode?: never }
    | { trigger?: never; triggerNode: React.ReactNode }
  );

function Menu({ trigger, triggerNode, header, children }: MenuProps) {
  return (
    <MenuTrigger>
      {triggerNode ?? (trigger && <Button {...trigger} />)}
      <DropdownPopover>
        {header && <div className={styles.menuHeader}>{header}</div>}
        <ReactAriaMenu className={styles.menu}>{children}</ReactAriaMenu>
      </DropdownPopover>
    </MenuTrigger>
  );
}

export default Menu;
